import { Contract } from '@mobi/web-native-comms'

export const ACCOUNT_CREATED_OPTIMOVE_EVENT: Contract['OPTIMOVE_TRACK'] = {
  eventName: 'account_created',
}

export const ACCOUNT_VERIFICATION_STATUS_OPTIMOVE_EVENT: Contract['OPTIMOVE_TRACK'] = {
  eventName: 'account_verification_status',
  data: { verified: true },
}
